import React from "react";
import { kgInspectorIcons } from "../../kg/canvas/inspector/kgInspectorIcons";
import { KgInspectorDataGrid } from "../KgInspectorDataGrid";
import { KgInspectorNavLinkButton } from "../../atoms/KgInspectorNavLinkButton";
import {
  CountBadge,
  EmptyHint,
  IconSlot,
  SectionHeader,
  SectionTitle,
  TabRoot,
} from "./KgInspectorLinksTab.styles";
import type { KgInspectorLinksTabProps } from "./KgInspectorLinksTab.types";

const LinksIcon = kgInspectorIcons.links;

export const KgInspectorLinksTab: React.FC<KgInspectorLinksTabProps> = ({
  links,
}) => (
  <TabRoot>
    <SectionHeader>
      <IconSlot>
        <LinksIcon size={16} />
      </IconSlot>
      <SectionTitle>Links</SectionTitle>
      {links.length > 0 && <CountBadge>{links.length}</CountBadge>}
    </SectionHeader>

    {links.length === 0 ? (
      <EmptyHint>No links defined for this ontology yet.</EmptyHint>
    ) : (
      <KgInspectorDataGrid
        rows={links}
        rowKey={(row) => row.id}
        columns={[
          {
            key: "source",
            header: "SOURCE",
            width: "flex",
            render: (row) =>
              row.sourceLink ? (
                <KgInspectorNavLinkButton link={row.sourceLink} />
              ) : (
                row.source
              ),
          },
          {
            key: "verb",
            header: "VERB",
            width: "flex",
            render: (row) => row.verb,
          },
          {
            key: "target",
            header: "TARGET",
            width: "flex",
            render: (row) =>
              row.targetLink ? (
                <KgInspectorNavLinkButton link={row.targetLink} />
              ) : (
                row.target
              ),
          },
        ]}
      />
    )}
  </TabRoot>
);

export default KgInspectorLinksTab;
